import { GetAdminExpenseResponse } from '@orbit/api-types'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useQuery } from '@tanstack/react-query'

/**
 * Fetches one expense's admin detail (GET /v1/admin/expenses/:id). Disabled until
 * the id is a valid positive number. Gated server-side by AdminGuard; a missing id
 * returns 404.
 */
export const useAdminExpense = (id: number) => {
	return useQuery<GetAdminExpenseResponse>({
		queryKey: queryKeys.adminExpense(id),
		queryFn: async () => {
			const response = await api.get<GetAdminExpenseResponse>(`/admin/expenses/${id}`)
			return response.data
		},
		enabled: Number.isFinite(id) && id > 0,
	})
}
